// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getSearchTypeLabel, isSearchPage } from "@mcmc/App/Store/Selectors/SearchResultsSelectors";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: McMcApplicationState) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ query?: string }>(location.search);
    return { searchLabel: getSearchTypeLabel(state), searchTerm: parsedQuery.query, isSearchPage: isSearchPage(state) };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

const SearchResultsTitle: FC<Props> = ({ searchLabel, searchTerm, isSearchPage }) => {
    if (!searchLabel || !searchTerm || !isSearchPage) {
        return null;
    }
    return <Typography variant="h1">{translate("{0} Results For: {1}", searchLabel, searchTerm)}</Typography>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SearchResultsTitle),
    definition: {
        group: "Product List",
        icon: "PageTitle",
    },
};

export default widgetModule;
